export default __webpack_public_path__ + "static/Mail-in-Instruction-Icon@2x-1a9c2aea43a61a53726baf2a98455cdc.png";